export class Project {

    constructor() {
        this.tags =[];
        this.links = {};
        this.info = {};
    }

    title:string;
    description:string;
    github:string;
    tags:string[];
    markdownLink:string;
    imageLink:string;
    videoLink:string;
    parsedmarkdown:string;
    links;

    info;

}
